import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U2103, { U2103ROLES } from "./U2103";
import U2103UserList from "./components/U2103UserList";
import U2103UserForm from "./components/U2103UserForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U2102Routes: RouteObject[] = [
  {
    path: "U2103",
    element: <U2000RequireRole allowedRoles={[U2103ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U2103 />,
        children: [
          { index: true, element: <U2103UserList /> },
          { path: ":id", element: <U2103UserForm /> },
        ],
      },
    ],
  },
];

export default U2102Routes;
